import { render, staticRenderFns } from "./NewTrade.vue?vue&type=template&id=18f11b94&"
import script from "./NewTrade.vue?vue&type=script&lang=js&"
export * from "./NewTrade.vue?vue&type=script&lang=js&"
import style0 from "./NewTrade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/geras/Documents/electros/magic-electros-crm/vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18f11b94')) {
      api.createRecord('18f11b94', component.options)
    } else {
      api.reload('18f11b94', component.options)
    }
    module.hot.accept("./NewTrade.vue?vue&type=template&id=18f11b94&", function () {
      api.rerender('18f11b94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/pages/LeadView/tabs/program/NewTrade.vue"
export default component.exports